import { WithTheme, withTheme } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core/styles';

import Container from '@material-ui/core/Container';
import GroupIcon from '@material-ui/icons/Group';
import MaterialTable from 'material-table';

import PersonIcon from '@material-ui/icons/Person';
import React, { Fragment } from 'react';

export interface IUserListProps extends WithTheme<any> {
    editable?: boolean;
    handleSelection?: any;
    users: any[];
    id: string;
}
const useStyles = makeStyles(theme => ({
    root: {
        '& th span.MuiTableSortLabel-active': {
            color: 'white',
        },
        '& thead span:hover': {
            color: 'white',
            textDecoration: 'underline',
        },
        '& thead svg': {
            color: 'white!important',
        },
        '& thead th': {
            borderBottom: theme.palette.primary.main,
            fontSize: 'inherit',
        },
        '& tr:hover': {
            cursor: 'pointer',
        },
    },
}));

function UserList({ editable = true, handleSelection, theme, users }: IUserListProps) {
    const classes = useStyles();
    //If this list is "editable", the users should be the "visibleUsers" list, otherwise it is the "checked" list
    //IF users is not explicitly passed:
    const { palette } = theme;

    let columns = [
        {
            field: 'name',
            title: 'Name',
        },
        {
            field: 'type',
            render: (rowData: any) => (rowData.type === 'group' ? <GroupIcon /> : <PersonIcon />),
            title: 'Type',
        },
    ];
    const options = {
        filterType: 'checkbox' as any,
        // onRowsSelect: props.handleRowSelect,
        showTextRowsSelected: false,
        selectableRowsHeader: false,
    };

    const rows = editable === false ? users.map(o => ({ ...o })) : users;

    return (
        <Fragment>
            <Container classes={{ root: classes.root }}>
                <MaterialTable
                    actions={[]}
                    columns={columns}
                    data={rows}
                    onSelectionChange={handleSelection}
                    options={{
                        emptyRowsWhenPaging: false,
                        headerStyle: {
                            backgroundColor: palette.primary.main,
                            color: palette.common.white,
                        },
                        searchFieldAlignment: 'left',
                        selection: editable,
                        ...options,
                    }}
                    style={{
                        boxShadow: 'none',
                        minHeight: '50vh',
                        width: '100%',
                    }}
                    title=""
                />
            </Container>
        </Fragment>
    );
}

export default withTheme(UserList);
